import Sentry from '@sentry/browser';
import React from 'react';

class ErrorBoundary extends React.Component<any, { error: any }> {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    this.captureError(error, errorInfo);
  }

  captureError = (error, errorInfo) => {
    if (window.__DEBUG__) {
      return;
    }
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  };

  render() {
    if (this.state.error) {
      return (
        <div>
          <pre>We're sorry — something's gone wrong.</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
